import { ACTIONS } from '../const';
import { switcher } from './utils';

export default switcher(
    {},
    {
        [ACTIONS.SYNC_AUTH_CODE](state, action) {
            const { appName, code } = action;
            return {
                ...state,
                [appName]: code,
            };
        },
    }
);



// WEBPACK FOOTER //
// ./src/reducers/auth_code.js